import { Button, Divider, Input, Modal, Select, Space, Spin, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { InboxOutlined, PlusOutlined, UserAddOutlined, UserOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { getParametre, saveDecaissement } from "../../../../hooks/useHooks";
import TextArea from "antd/es/input/TextArea";
import { PARAMETERS } from "../../../../variables/constants";
import AmountInputNumber from "../../../../components/inputs/AmountInputNumber";
import axiosInstance from "../../../../variables/api/axiosInstance";

const { Option } = Select;
const { Title } = Typography;

const ReglementRecoursModal = ({ sinistre, modalControl }) => {
    let victimes = sinistre.victimes || [];
    const experts = sinistre.experts || [];
    const evaluations = sinistre.evaluations || [];
    const [beneficiairesVictimes, setBeneficiairesVictimes] = useState([]);
    const [beneficiairesExperts, setBeneficiairesExperts] = useState([])
    const [sousEvaluationsSelected, setSousEvaluationsSelected] = useState([])
    const [montantReglement, setMontantReglement] = useState(0)
    const [beneficiaire, setBeneficiaire] = useState(null)
    const [isVictimeBeneficiaire, setIsVictimeBeneficiaire] = useState(null)
    const [completeSousEvSelected, setCompleteSousEvSelected] = useState([])
    const [honoraire, setHonoraire] = useState(0)
    const [decaissementLoading, setDecaissementLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [motifsLoading, setMotifsLoading] = useState(false);
    const [motifs, setMotifs] = useState([]);
    const [name, setName] = useState('');
    const [motifReglement, setMotifReglement] = useState();
    const [textValue, setTextValue] = useState('');
    // Compagnie(s) contre qui le recours est exercé = PAYEUR(S) possible(s) de l'encaissement.
    // sinistre.compagniesRecours = codes d'organisme → on résout les raisons sociales.
    const [recoursCompanies, setRecoursCompanies] = useState([]);

    const inputRef = useRef(null);

    useEffect(() => {
        const codes = Array.isArray(sinistre?.compagniesRecours) ? sinistre.compagniesRecours : [];
        if (!codes.length) { setRecoursCompanies([]); return; }
        axiosInstance.get("/api/organisme/assurance")
            .then((res) => {
                const byCode = {};
                (res?.data || []).forEach((o) => { if (o?.code) byCode[o.code] = o.raisonSociale || o.code; });
                setRecoursCompanies(codes.map((c) => ({ code: c, nom: byCode[c] || c })));
            })
            .catch(() => setRecoursCompanies(codes.map((c) => ({ code: c, nom: c }))));
    }, [sinistre?.codeId, sinistre?.compagniesRecours]);


    const handleRetrieveBeneficiaire = (value) => {
        if (isVictimeBeneficiaire && value.length > 0) {
            setBeneficiaire(victimes?.filter((v) => v.codeId === value)[0])
        }
        if (isVictimeBeneficiaire === false && value.length > 0) {
            setBeneficiaire(experts?.filter((v) => v.codeId === value)[0])
        }
    }

    const handleBeneficiaireChange = (value) => {
        setBeneficiairesVictimes(value);
        handleRetrieveBeneficiaire(value);
    };
    const handleExpertChange = (value) => {
        setBeneficiairesVictimes(value);
        // Résolution du bénéficiaire/payeur : compagnie du recours (payeur), sinon victime, sinon expert.
        const compagnie = recoursCompanies?.find((c) => c.code === value);
        if (compagnie) {
            // Compagnie « payeur » → persistée côté backend comme Personne (nom = raison sociale).
            setBeneficiaire({ nom: compagnie.nom });
            return;
        }
        const victime = victimes?.find((v) => v.codeId === value);
        if (victime) {
            setBeneficiaire(victime);
            return;
        }
        const expert = experts?.find((v) => v.codeId === value);
        setBeneficiaire(expert || null);
        if (expert) setBeneficiairesExperts(value);
    };

    const handleSousEvChange = (value) => {
        setSousEvaluationsSelected(value);
        const tempSous = sousEvaluations?.filter((v) => sousEvaluationsSelected?.includes(v.codeId))
        setCompleteSousEvSelected(tempSous)
    };

    const hendleBeneficiaireIsVictimeChoice = (value) => {
        setIsVictimeBeneficiaire(value)
    }
    victimes = victimes.filter((victime) => victime.personne)
    const evaluation = evaluations.filter((evaluation) => evaluation.courant)[0]
    const sousEvaluations = evaluation?.sousEvaluations
    const filteredSousEvaluations = sousEvaluations?.filter(sousEval => beneficiairesVictimes?.includes(sousEval?.victime?.codeId));


    console.log(beneficiairesVictimes)
    console.log(sousEvaluationsSelected)
    console.log(completeSousEvSelected)
    const totalMontant = sousEvaluations?.prejudices?.reduce(
        (acc, curr) => acc + (curr.montant || 0), 0
    );

    const [isPartielOrTotal, setIsPartielOrTotal] = useState(false)

    useEffect(() => {
        const fetchMotifs = async () => {
            setMotifsLoading(true)
            const response = await getParametre(PARAMETERS.motifReglement)
            console.log("motifs: ", response.data)
            setMotifs(response.data)
            setMotifsLoading(false)
        }
        fetchMotifs()
    }, []);

    useEffect(() => {
        if (motifs) {
            // Dé-duplication par libellé affiché (évite les répétitions dans la liste déroulante).
            const seen = new Set();
            const opts = [];
            motifs.forEach((motif) => {
                const v = motif?.valeur || motif?.libelleParametre || "";
                const key = String(v).trim().toLowerCase();
                if (!key || seen.has(key)) return;
                seen.add(key);
                opts.push({ label: v, value: v });
            });
            setOptions(opts);
        }
    }, [motifs]);

    // Called when a motif is selected
    const onMotifSelect = (value) => {
        handleFindMotif(value); // This should eventually call setTextValue with content
        const selectedOption = options.find(opt => opt.value === value);
        setTextValue(selectedOption?.label || '');
    };


    const handleFindMotif = (e) => {
        setMotifReglement(e)
    }

    const addItem = (e) => {
        e.preventDefault();

        if (!name?.trim()) {
            return; // Prevent adding empty or whitespace-only items
        }

        setOptions((prevOptions) => [...prevOptions, { label: name, value: name }]); // Update options immutably

        setName(""); // Clear the input field

        inputRef.current?.focus(); // Focus the input directly
    };

    // Piste recours : PAS d'encaissement sans ÉVALUATION de recours. SAP recours = reste à encaisser.
    const evalRecoursVal = Number(sinistre?.evaluationRecours) || 0;
    const hasEvalRecours = evalRecoursVal > 0;
    const sapRecoursVal = sinistre?.sapRecours != null ? Number(sinistre.sapRecours) : evalRecoursVal;

    return (<>
        <Modal
            title={'Règlement Recours Sinistre'}
            open={modalControl.open}
            confirmLoading={decaissementLoading}
            style={{
                width: '500px'
            }}
            onCancel={() => {
                modalControl.setOpen(false)
                setIsVictimeBeneficiaire(null)
                setBeneficiaire(null)
                setIsPartielOrTotal(null)
            }}
            okText="Valider"
            cancelText="Annuler"
            onOk={async () => {
                setDecaissementLoading(true);

                if (!beneficiaire) {
                    toast.error("Veuillez choisir un beneficiaire");
                    setDecaissementLoading(false);
                    return;
                }
                if (!motifReglement) {
                    toast.error("Veuillez choisir un motif de reglement");
                    setDecaissementLoading(false);
                    return;
                }

                if (!montantReglement) {
                    toast.error("Veuillez renseigner le montant du reglement");
                    setDecaissementLoading(false);
                    return;
                }

                // Garde : pas d'encaissement de recours sans évaluation de recours.
                if (!hasEvalRecours) {
                    toast.error("Aucune évaluation de recours sur ce dossier : encaissement impossible. Évaluez d'abord le recours.");
                    setDecaissementLoading(false);
                    return;
                }
                // Garde : ne pas dépasser le reste à encaisser (SAP recours).
                if (parseFloat(montantReglement) > sapRecoursVal + 0.01) {
                    toast.error(`Le montant dépasse le reste à encaisser (SAP recours = ${Math.round(sapRecoursVal).toLocaleString("fr-FR")} F).`);
                    setDecaissementLoading(false);
                    return;
                }

                let result = {
                    beneficiaire: beneficiaire.personne ? beneficiaire?.personne : beneficiaire,
                    montantGlobal: parseFloat(montantReglement),
                    sinistre: sinistre,
                    motifReglement: textValue,
                    formuleDeFin: motifReglement,
                    expertise: false,
                    encaissement: true,
                    nature: "RECOURS",
                };

                console.log("Decaissement Result:", result);

                try {
                    await saveDecaissement(result);
                    toast.success('Encaissement de recours enregistré !');
                    setDecaissementLoading(false);
                    modalControl.setOpen(false);
                    // Rafraîchit le dossier pour que le nouvel encaissement APPARAISSE dans la liste
                    // (et devienne éligible à l'assignation d'un chèque).
                    if (typeof modalControl.onSaved === "function") modalControl.onSaved();
                } catch (e) {
                    setDecaissementLoading(false);
                    toast.error(e?.response?.data?.message || e?.response?.data?.error || `Une erreur s'est produite !`);
                    console.error("Error:", e, "Result:", result);
                }
            }

            }
        >

            <div className="col-12">
                <label
                    style={{
                        margin: "15px 0 5px 0",
                    }}
                >
                    Sélectionner le payeur (bénéficiaire) *
                </label>
                <Select
                    name="beneficiaire"
                    value={beneficiairesVictimes}
                    placeholder="Compagnie du recours, victime ou expert"
                    style={{ width: "100%" }}
                    onChange={handleExpertChange}
                    options={[
                        {
                            label: <span>Compagnie(s) du recours — payeur</span>,
                            title: 'Compagnie(s) du recours',
                            options: recoursCompanies?.map((c) => ({
                                label: c.nom,
                                value: c.code
                            }))
                        },
                        {
                            label: <span>Victime(s)</span>,
                            title: 'Victime(s)',
                            options: victimes?.map((victime) => ({
                                label: `${victime.personne?.nom} ${victime.personne?.prenom}`,
                                value: victime.codeId
                            }))
                        },
                        {
                            label: <span>Expert(s)</span>,
                            title: 'Expert(s)',
                            options: experts?.map((expert) => ({
                                label: `${expert?.nom} ${expert?.prenom}`,
                                value: expert.codeId
                            }))
                        },
                    ]}
                />
            </div>
            <div className="col-12">
                <label
                    style={{
                        margin: "15px 0 5px 0",
                    }}
                >
                    Motif de règlement *
                </label>
                <Spin spinning={motifsLoading}>
                    <Select
                        id="motifRevision"
                        name="motifRevision"
                        placeholder="Motif de l'encaissement"
                        style={{ width: '100%', height: '50px' }}
                        dropdownRender={menu => (
                            <>
                                {menu}
                                <Divider style={{ margin: '8px 0' }} />
                                <Space style={{ padding: '0 8px 4px' }}>
                                    <Input
                                        placeholder="Ajouter un motif"
                                        ref={inputRef}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <Button
                                        type="text"
                                        icon={<PlusOutlined />}
                                        onClick={addItem}
                                    >
                                        Ajouter un motif
                                    </Button>
                                </Space>
                            </>
                        )}
                        options={options}
                        onChange={onMotifSelect}
                        value={motifReglement}
                    />
                    <TextArea
                        rows={5}
                        value={textValue}
                        onChange={(e) => setTextValue(e.target.value)}
                        placeholder="Modifier le motif ici..."
                        style={{ marginTop: 10 }}
                    />
                </Spin>
            </div>
            <div className="col-12">
                <label
                    style={{
                        margin: "15px 0 5px 0",
                    }}
                >
                    Montant de l'encaissement
                </label>
                <div style={{ fontSize: 12, color: hasEvalRecours ? "#d46b08" : "#cf1322", marginBottom: 4 }}>
                    {hasEvalRecours
                        ? <>Reste à encaisser (SAP recours) : <b>{Math.round(sapRecoursVal).toLocaleString("fr-FR")} F</b></>
                        : "Aucune évaluation de recours : encaissement impossible."}
                </div>

                <AmountInputNumber
                    name="montantReglement"
                    value={montantReglement || 0}
                    placeholder="Saisir le montant de l'encaissement"
                    style={{ width: '100%' }}
                    onChange={(value) => {
                        if (value === null || value === undefined || value === "") {
                            setMontantReglement(0);
                            return;
                        }
                        const nextValue = Number(value);
                        setMontantReglement(Number.isNaN(nextValue) ? 0 : nextValue);
                    }}
                />
            </div>
        </Modal>
    </>);
};

export default ReglementRecoursModal;
